export const SIGNAL_TYPE_HEADER_NAME = 'Type'
